import { useRef, useEffect } from 'react';
import MagnifyingGlassRegularIcon from '../../icons/magnifying-glass-regular';
import React from 'react';

const SearchBarComponentUi = ({
    inputValue = '',
    onChange,
    className = '',
    placeholder = 'Search by Name, UHID, Phone Number, Service or Tag',
}: {
    inputValue: string;
    onChange: React.ChangeEventHandler<HTMLInputElement> | undefined;
    className?: string;
    placeholder?: string;
}): JSX.Element => {
    const ref = useRef<HTMLInputElement>(null);
    useEffect(() => {
        if (ref.current) {
            ref.current?.focus();
        }
    }, [ref]);

    return (
        <div
            className={`dr-px-16 dr-bg-darwin-neutral-0 dr-border-b-1 ${
                inputValue.length
                    ? 'dr-rounded-t-8 dr-border-darwin-neutral-200'
                    : 'dr-rounded-8 dr-border-transparent'
            } dr-flex dr-items-center dr-space-x-16 ${className}`}
        >
            <MagnifyingGlassRegularIcon className="dr-w-24 dr-h-24 dr-p-4 dr-text-darwin-neutral-1000" />
            <input
                ref={ref}
                value={inputValue}
                onChange={onChange}
                autoFocus={true}
                className="dr-flex-1 dr-py-12 focus:dr-outline-none TouchCalloutRegular placeholder:dr-text-darwin-neutral-400 dr-text-darwin-neutral-800"
                placeholder={placeholder}
            />
            {/* <UserPlusRegularIcon className="dr-w-24 dr-h-24 dr-p-4 dr-text-darwin-primary-primary" /> */}
        </div>
    );
};

export default SearchBarComponentUi;
